import { Box, Button, Grid, Stack, TextField } from "@mui/material";

import {
  ErrorTypography,
  SecondaryTypography,
  StyledTypography,
  TypographyDefault,
} from "../../../Theme";
import { validateAdministratorDetails } from "../../../utils/validate";

const AdministratorDetails = ({
  administratorDetails,
  setAdministratorDetails,
  administratorErrText,
  setAdministratorErrText,
  setaddblocks,
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAdministratorDetails((prev) => ({ ...prev, [name]: value }));
    setAdministratorErrText((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleContinue = () => {
    if (
      validateAdministratorDetails(
        administratorDetails,
        administratorErrText,
        setAdministratorErrText
      )
    ) {
      setaddblocks({
        Company_Details: false,
        Project_Information: false,
        Administrator_Details: false,
        Review_Account: true,
      });
    }
  };
  return (
    <>
      <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <Box style={{ flexDirection: "column" }}>
            <SecondaryTypography>Administrator Details</SecondaryTypography>
            <TypographyDefault style={{ marginTop: "5px" }}>
              These details will be used for the purpose of signing up as a
              Super Admin.
            </TypographyDefault>
          </Box>
        </Stack>
        <Box component="form">
          <Grid
            container
            xs={12}
            gap="20px"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              // borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12} md={5.77}>
              <StyledTypography>Full Name</StyledTypography>
              <TextField
                name="full_name"
                // placeholder="Enter Project Title"
                placeholder="Enter Full Name"
                InputProps={{ disableUnderline: true }}
                
                onChange={handleInputChange}
                value={administratorDetails?.full_name}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: administratorErrText?.full_name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: administratorErrText?.full_name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {administratorErrText?.full_name && (
                <ErrorTypography>
                  {administratorErrText?.full_name}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Email Address</StyledTypography>
              <TextField
                name="email_address"
                // placeholder="Type"
                placeholder="Enter Company Email Address"
                onChange={handleInputChange}
                value={administratorDetails?.email_address}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: administratorErrText?.email_address
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: administratorErrText?.email_address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              {administratorErrText?.email_address && (
                <ErrorTypography>
                  {administratorErrText?.email_address}
                </ErrorTypography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Stack
        direction="row"
        py={1}
        px={1}
        mt={3}
        justifyContent="end"
        alignItems="center"
        height="60px"
        sx={{
          backgroundColor: "white",
          border: "1px solid #E5E7EB",
          borderRadius: "0 0 8px 8px ",
        }}
      >
        <Stack direction="column" justifyContent="end" alignItems="end">
          <Button type="button" onClick={handleContinue} variant="Standard">
            Continue
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

export default AdministratorDetails;
